import {makeAutoObservable} from "mobx";
import {IProductCaseOffer, PRODUCT_CASE_OFFER_STATUS} from "../rma-types";
import {INCENTIVE_VIRTUAL_CURRENCIES} from "../../../../models/User";
import RmaPolicyRuleStore from "./rma-policy-rule-store";
import ProductCaseStore from "./product-case-store";
import currentPortalStore from "../../../../stores/current-portal-store";

class RmaOfferStore {
    private _model: IProductCaseOffer = {} as IProductCaseOffer;
    private _policyRuleStore: RmaPolicyRuleStore = {} as RmaPolicyRuleStore;
    
    constructor(private _productCaseStore: ProductCaseStore, model: IProductCaseOffer) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._setModel(model);
    }
    
    public get status(): PRODUCT_CASE_OFFER_STATUS { return this._model.status; }
    public get credits(): number { return this._model.credits; }
    public get switchToExchangeIncentiveAmount(): number { return this._model.switch_to_exchange_incentive ?? 0; }
    public get switchToExchangeIncentiveVirtualCurrency(): INCENTIVE_VIRTUAL_CURRENCIES|null { return this._model.incentive_virtual_currency ?? currentPortalStore.setting?.switchToExchangeStore?.incentiveCurrency as INCENTIVE_VIRTUAL_CURRENCIES; }
    public get returnLabelFee(): number|null { return this._model.return_label_fee; }
    public get fee(): number|null { return this._model.fee; }
    public get policyRuleStore(): RmaPolicyRuleStore { return this._policyRuleStore; }
    public get productCaseStore(): ProductCaseStore { return this._productCaseStore; }
    
    private _setModel(model: IProductCaseOffer){
        this._model = ensureValidModel(model);
        this._policyRuleStore = new RmaPolicyRuleStore(this, model.policy_rule);
    }
}

export { RmaOfferStore as default };

function ensureValidModel(model: IProductCaseOffer){
    const ensureValidNumber = (v: undefined | any) => {
        const toNumber = Number(v);
        if (isNaN(toNumber)) {
            return 0;
        }
    
        return toNumber;
    };

    return {
        ...model,
        credits: ensureValidNumber(model.credits),
        switch_to_exchange_incentive: ensureValidNumber(model.switch_to_exchange_incentive),
        return_label_fee: ensureValidNumber(model.return_label_fee),
        fee: ensureValidNumber(model.fee),
    }
}
